// src/pages/DirectIncomeBalance/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import DirectIncomeBalanceFilters from "./components/DirectIncomeBalanceFilters";
import DirectIncomeBalanceTable from "./components/DirectIncomeBalanceTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportDirectIncomeBalanceCsv } from "./components/exportDirectIncomeBalanceCsv";

const { Title } = Typography;

const DirectIncomeBalance = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list, balanceTotal } = useSelector(
    (state) => state.directIncomeBalance
  );
  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Direct Income Balance Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportDirectIncomeBalanceCsv({
      list,
      balanceTotal,
      title:    "Direct Income Balance Report",
      filename: "direct_income_balance",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={<Title level={4} style={{ margin: 0 }} className="reportBigTitle" >Direct Income Balance Report</Title>}
                    extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }

          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <DirectIncomeBalanceFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <DirectIncomeBalanceTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Direct Income Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <DirectIncomeBalanceTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default DirectIncomeBalance;
